import React, { Component } from "react";
import "../css/smallSearchResult.css";
var EventEmitter = require('wolfy87-eventemitter');
var ee = new EventEmitter();

class SmallSearchResult extends Component {

    constructor(props) {
        super(props);
        this.state = {
            planIdClass: "planId",
            imageBorderClass: "resultImage"
        }
    }

    render() {

        const image = this.props.image;
        const planId = this.props.planId;

        return (
            <a onClick={this.registerClick} className="resultHolder">
                <img className={this.state.imageBorderClass} src={image} />
                <div className={this.state.planIdClass}>{planId}</div>
            </a>
        );
    }

    registerClick = () => {
        ee.emitEvent('smallResultClicked');
        this.props.setState({ planId: this.props.planId });
        setTimeout(() => {
            this.setState({
                planIdClass: "planIdBold",
                imageBorderClass: "resultImageHighlighted"
            });
        }, 100);
    }

    listener = () => {
        this.setState({
            planIdClass: "planId",
            imageBorderClass: "resultImage"
        })
    }

    componentDidMount() {
        ee.addListener('smallResultClicked', this.listener);
        if (this.props.num == 0) {
            setTimeout(() => {
                this.setState({
                    planIdClass: "planIdBold",
                    imageBorderClass: "resultImageHighlighted"
                });
            }, 100);
        }
    }

    componentWillUnmount() {
        ee.removeListener('smallResultClicked', this.listener);
    }

}

export default SmallSearchResult;